import Checkers from './class/Checkers';

export function buildWebHotelierUrl ( propertyBookingTypeValue, webHotelierBookUrl, bookingTypeValue, roomCodes, checkin, checkout, adults, kids, infants, rooms ) {
  const source = Checkers.isValidString( bookingTypeValue ) ? bookingTypeValue
      : Checkers.isValidString( webHotelierBookUrl ) ? webHotelierBookUrl
          : propertyBookingTypeValue;

  const isWebHotelierSource = Checkers.isValidString( webHotelierBookUrl ) && source === webHotelierBookUrl;

  if ( !Checkers.isValidString( source ) ) {
    return null;
  }

  const [ base, query ] = source.split( '?' );

  if ( !Checkers.isValidString( base ) ) {
    return null;
  }

  const params = new URLSearchParams( query || '' );

  if ( Checkers.isValidString( checkin ) ) {
    params.set( 'checkin', checkin );
  }
  if ( Checkers.isValidString( checkout ) ) {
    params.set( 'checkout', checkout );
  }
  if ( adults != null ) {
    params.set( 'adults', String( adults ) );
  }
  if ( kids != null ) {
    params.set( 'children', String( kids ) );
  }
  if ( infants != null ) {
    params.set( 'infants', String( infants ) );
  }
  if ( rooms != null && Number( rooms ) > 0 ) {
    params.set( 'rooms', String( rooms ) );
  }

  const validRoomCodes = Checkers.isValidArray( roomCodes )
      ? roomCodes.filter( ( code ) => Checkers.isValidString( code ) )
      : [];

  if ( validRoomCodes.length > 0 && ( isWebHotelierSource || params.has( 'room' ) ) ) {
    params.set( 'room', validRoomCodes.join( ',' ) );
    params.set( 'exclusive', '1' );
  }

  const queryString = params.toString();
  return queryString.length > 0 ? base + '?' + queryString : base;
}

export function redirectToWebHotelier ( propertyBookingTypeValue, webHotelierBookUrl, bookingTypeValue, roomCodes, checkin, checkout, adults, kids, infants, rooms ) {
  const url = buildWebHotelierUrl( propertyBookingTypeValue, webHotelierBookUrl, bookingTypeValue, roomCodes, checkin, checkout, adults, kids, infants, rooms );
  if ( url == null ) {
    return false;
  }

  window.open( url, '_blank' );
  return true;
}

// Booking types (property_booking_types): 1 Loggia, 2 booking button (html), 3 WebHotelier, 4 other, 5 Cosmores, 6 Booking Solutions
export type BookingMode = 'loggia' | 'webhotelier' | 'button' | 'other' | 'none'

// Same decision as the Lodge site: the booking type of the site (app) wins when it is set, otherwise the type of the
// property decides. A stored booking value only counts for the type it belongs to, so a leftover WebHotelier url on a
// property that books through Loggia is ignored.
export function resolveBookingMode ( appTypeId, appTypeValue, propertyTypeId, propertyTypeValue ) : { mode: BookingMode, value: string | null } {
  const byType = ( typeId, value ) : { mode: BookingMode, value: string | null } => {
    const hasValue = Checkers.isValidString( value );
    switch ( Number( typeId ) ) {
      case 1: return { mode: 'loggia', value: null };
      case 2: return hasValue ? { mode: 'button', value } : { mode: 'none', value: null };
      case 3: return hasValue ? { mode: 'webhotelier', value } : { mode: 'none', value: null };
      case 4: return hasValue ? { mode: 'other', value } : { mode: 'none', value: null };
      default: return { mode: 'none', value: null };
    }
  };

  if ( appTypeId != null && appTypeId !== '' ) {
    // on the site level only the types with a value work (the Lodge shows nothing for the others)
    const result = byType( appTypeId, appTypeValue );
    return result.mode === 'loggia' ? { mode: 'none', value: null } : result;
  }

  if ( propertyTypeId != null && propertyTypeId !== '' ) {
    return byType( propertyTypeId, propertyTypeValue );
  }

  return { mode: 'none', value: null };
}
